import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ReactionButton from '../ReactionButton';
import { CommentReaction } from '../../redux/types';
import s from './ReactionList.scss';
var ReactionList = function (_a) {
    var className = _a.className, comment = _a.comment, toggleReactionToComment = _a.toggleReactionToComment;
    var t = useTranslation().t;
    var handleReactionClick = function (reaction) { return function (ev) {
        // Stop propagating click to parent to avoid double "like"
        ev.stopPropagation();
        toggleReactionToComment(comment, reaction);
    }; };
    return (React.createElement("div", { className: cn(s['root'], className) },
        React.createElement(ReactionButton, { iconUrl: "https://st.deviantart.net/emoticons/h/heart.gif", text: t('comment.reactions.like'), onClick: handleReactionClick(CommentReaction.Like) }),
        React.createElement(ReactionButton, { iconUrl: "https://st.deviantart.net/emoticons/l/love2.gif", text: t('comment.reactions.love'), onClick: handleReactionClick(CommentReaction.Love) }),
        React.createElement(ReactionButton, { iconUrl: "https://st.deviantart.net/emoticons/h/hug.gif", text: t('comment.reactions.hug'), onClick: handleReactionClick(CommentReaction.Hug) }),
        React.createElement(ReactionButton, { iconUrl: "https://st.deviantart.net/emoticons/w/worships.gif", text: t('comment.reactions.bravo'), onClick: handleReactionClick(CommentReaction.Bravo) }),
        React.createElement(ReactionButton, { iconUrl: "https://st.deviantart.net/emoticons/l/la.gif", text: t('comment.reactions.wow'), onClick: handleReactionClick(CommentReaction.Wow) })));
};
ReactionList.displayName = 'ReactionList';
export default ReactionList;
//# sourceMappingURL=ReactionList.js.map